module.exports = __webpack_public_path__ + "static/media/kushner-jerusalem.f76eea4a.webp";